import React from "react";
import {HelpDirectoryRepository} from "../../../repository";
import {EntityFormTemplate} from "../../../component/template/EntityFormTemplate";
import {HelpDirectory} from "../../../model";
import * as Yup from 'yup';

export const CreateHelpDirectory = () => {

    return (
        <EntityFormTemplate<HelpDirectory>
            mode={'create'}
            repository={new HelpDirectoryRepository()}
            title={{
                page: `Répertoire (Aide en ligne)`,
                schema: `Ajouter un répertoire`
            }}
            fields= {[
                { label: `Nom`, id: 'name', type: 'text' },
                { label: `Permission`, id: 'permission', type: 'text' },
            ]}
            validationSchema={
                Yup.object().shape({
                    name: Yup.string()
                        .min(3, 'Minimum 3 caractères.')
                        .max(200, 'Maximum 200 caractères.')
                        .required('Obligatoire'),
                })
            }
        />
    )
}